import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import QrReader from "react-web-qr-reader";
import * as Icon from "react-bootstrap-icons";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Form from 'react-bootstrap/Form';


const Scanner = () => {
  const NotRegistered = () =>
    toast.error("Sorry, This user is not registered for event");
  const SuccessRegistered = () => toast.success("Participant Confirmed!");

  const InvalidQR = () => toast.error("Scanned QR is Invalid")

  const [facingMode, setFacingMode] = useState("user");
  const [result, setResult] = useState("");

  const [userDetails, setUserDetails] = useState("");
  useEffect(() => {
    getLoginDetails();
  }, []);

  const getLoginDetails = () => {
    const loginDetails = JSON.parse(localStorage.getItem("User"));
    console.log("loginDetails", loginDetails);
    setUserDetails(loginDetails.user);
  };

  const [showQrDetails, setShowQrDetails] = useState(false);
  const [showConfirmed, setShowConfirmed] = useState(false);
  const [modalData, setModalData] = useState("");
  const [uniqueId, setUniqueId] = useState("");

  const handleScan = (data) => {
    console.log(
      "--------------React QR Reader Data-----------",
      data.data
    );
    console.log("UserDetails", userDetails.user_id);
    try {
      if (data != null || data !== undefined) {
        console.log("Event data", JSON.parse(data.data));
        let val = JSON.parse(data.data);
        if (val !== null && val !== undefined ) {
          setShowQrDetails(true);
          setModalData(JSON.parse(data.data));
        }
      }
    } catch (e) {
      console.log(e);
      InvalidQR()
    }
  };

  const handleEror = (err) => {
    console.log(err);
  };

  const handleEnterUniqueId = () => {
    if (uniqueId.trim() !== "") {
      setShowQrDetails(true);
      setModalData({ name: "Name from ID", mobile: "Mobile from ID" }); // Sample data from unique ID
    } else {
      // Handle empty unique ID case

      toast.error("Please enter a unique ID Or Scan QR.");
    }
  };

  const previewStyle = {
    height: 300,
    width: 300,
    display: "flex",
    justifyContent: "center",
  };

  const camStyle = {
    display: "flex",
    justifyContent: "center",
  };

  const ConfirmEventAttendance = async ()=>{
    setShowQrDetails(false)
    setIsScanning(false)
    toast.success("successfully fetch data")
  }

  const [isScanning, setIsScanning] = useState(false);

  return (
    <>
      <div>
        <ToastContainer />
        <div data-aos="fade-up" style={{display:"flex",justifyContent:"center"}}>
         
        

          <Row className="m-3 " >

              {!isScanning ? (
                <>
                  <Col md={3} sm={12} style={{display:"flex", justifyContent:"center"}}>
                  <Button  onClick={() => setIsScanning(true)}>Scan QR Code</Button>{" "} 
                  </Col>
                  <Col md={1} sm={12} style={{display:"flex", justifyContent:"center",justifyItems:"center"}}>OR</Col>
                  {/* <Col md={7} sm={8} style={{display:"flex",justifyContent:"space-between"}}>  */}
                  <Col md={6} sm={4} xs={12} style={{display:"flex", justifyContent:"center"}}
                  >
                  {/* <input
                  className="m-2" 
                    placeholder="Enter Unique Id"
                    value={uniqueId}
                    onChange={(e) => setUniqueId(e.target.value)}
                    /> */}
                    <Form.Control type="text"   placeholder="Normal text" />

                  </Col>
                  <Col md={2} sm={1} xs={12} style={{display:"flex", justifyContent:"center"}}>
                  <Button className="m-2" onClick={handleEnterUniqueId}>Submit</Button>
                  </Col>

                    

                 
                    {/* </Col> */}
                </>
              ) : (
                <div style={camStyle}>
                  <QrReader
                    style={previewStyle}
                    onError={handleEror}
                    onScan={handleScan}
                    facingMode="user"
                  />
                </div>
              )}
          </Row>
        </div>
      </div>

      <Modal
        show={showQrDetails}
        onHide={() => setShowQrDetails(false)}
        size="lg"
        centered
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Scanned QR Data
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>
            <Icon.Person className="me-2" />
            Candidate Name: {modalData.name}
          </h4>
          <h4>
            <Icon.Telephone className="me-2" />
            Candidate Mobile Number: {modalData.email}
          </h4>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowQrDetails(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={ConfirmEventAttendance}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showConfirmed}
        onHide={() => {
          setShowConfirmed(false);
          setShowQrDetails(false);
        }}
        size="lg"
        centered
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Already Confirmed
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>
            <Icon.Person className="me-2" />
            Candidate Name: {modalData.name}
          </h4>
          <h4>
            <Icon.Telephone className="me-2" />
            Candidate Mobile Number: {modalData.mobile}
          </h4>
          <h2>This Event QR is already Confirmed or Scanned</h2>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowConfirmed(false);
              setShowQrDetails(false);
            }}
          >
            ok
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Scanner;
